import { __extends } from "tslib";
import { FilterUtils } from '../../../utils/FilterUtils';
import { GradientAtlas } from '../../../utils/GradientAtlas';
import { TaskBaseWebGL } from './TaskBaseWebgGL';
var VERTEX = "\nprecision highp float;\nuniform vec4 uTexMatrix[2];\nuniform vec4 uTexMatrixSource;\n\n/* AGAL legacy atribb resolver MUST reolver this as va0 */\nattribute vec4 aPos; // position\n\nvarying vec2 vUv[2];\n\nvoid main() {\n\tvec4 pos = aPos;\n\n\tpos.xy = pos.xy * uTexMatrix[0].zw + uTexMatrix[0].xy;\n\tpos.z = pos.z * 2.0 - pos.w;\n\n    gl_Position = pos;\n\n\tvUv[0] = clamp((aPos.xy * uTexMatrix[1].zw) + uTexMatrix[1].xy, 0., 1.);\n\tvUv[1] = clamp((aPos.xy * uTexMatrixSource.zw) + uTexMatrixSource.xy , 0., 1.);\n}\n\n";
var COLOR_MODE_PART = "\nuniform vec4 uHColor;\nuniform vec4 uSColor;\n\nvec4 bevel(float shadow, float high) {\n\tfloat factor = high - shadow;\n\n\tshadow = min(1., max(0., factor) * uStrength) * uSColor.a;\n\thigh = min(1., max(0., -factor) * uStrength) * uHColor.a;\n\n\treturn vec4(uSColor.rgb * shadow + uHColor.rgb * high, shadow + high);\n}";
var GRAD_MODE_PART = "\n// gradient\nuniform sampler2D uGrad;\nuniform float uGradIndex;\n\nvec4 bevel(float shadow, float high) {\n\tshadow *= uStrength;\n\thigh *= uStrength;\n\n\tvec2 pos = vec2(0.5 * (1. + shadow - high), uGradIndex);\n\n\treturn texture2D(uGrad, pos) * (shadow + high);\n}";
var FRAG = function (mode, knokout, type) {
    if (mode === void 0) { mode = "color" /* COLOR */; }
    if (knokout === void 0) { knokout = false; }
    if (type === void 0) { type = 'inner'; }
    return "\nprecision highp float;\nvarying vec2 vUv[2];\n\nuniform float uStrength;\nuniform vec2 uDir;\n\n/* AGAL uniforms will be reolved this as fs0 */\n// blur\nuniform sampler2D uBlur;\n/* AGAL uniforms will be reolved this as fs1 */\n// source\nuniform sampler2D uSource;\n" + (mode === "color" /* COLOR */ ? COLOR_MODE_PART : GRAD_MODE_PART) + "\n\nvoid main() {\n\tvec4 color = texture2D(uSource, vUv[1]);\n\t\n\tfloat a = color.a;\n\n\t// LOOL.. there are a bug - we PMA it twice, devide to compense\n\t// if (a > 0.) color.a /= a;\n\n\tfloat shadow = texture2D(uBlur, vUv[0] + uDir).a;\n\tfloat high = texture2D(uBlur, vUv[0] - uDir).a;\n\t" + (!type || type === 'inner' ? 'vec4 outColor = bevel(shadow, high) * color.a;' : '') + "\n\t" + (type === 'outer' ? 'vec4 outColor = bevel(shadow, high) * (1.0 - color.a);' : '') + "\n\t" + (type === 'full' ? 'vec4 outColor = bevel(shadow, high);' : '') + "\n\t" + (knokout
        ? 'gl_FragColor = outColor;'
        : 'gl_FragColor = color * (1.0 - outColor.a) + outColor;') + "\n\n\t//gl_FragColor *= a;\n}";
};
var BevelTask = /** @class */ (function (_super) {
    __extends(BevelTask, _super);
    function BevelTask() {
        var _this = _super.call(this) || this;
        _this.activateInternaly = false;
        _this._currentIndex = 0;
        _this._gradInvalid = false;
        _this._renderMode = "color" /* COLOR */;
        _this._shadowColor = 0x0;
        _this._shadowAlpha = 1;
        _this._highlightColor = 0xfffff;
        _this._highlightAlpha = 1;
        _this._dirInvalid = false;
        _this._angle = 45;
        _this._distance = 4;
        _this.strength = 1;
        _this._knockout = false;
        _this._type = 'inner';
        _this._focusId = -1;
        return _this;
    }
    Object.defineProperty(BevelTask.prototype, "name", {
        get: function () {
            return 'BevelTask:' + this._renderMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "renderMode", {
        get: function () {
            return this._renderMode;
        },
        set: function (v) {
            if (v === this._renderMode)
                return;
            this._renderMode = v;
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "shadowColor", {
        get: function () {
            return this._shadowColor;
        },
        set: function (value) {
            if (this.shadowColor === value)
                return;
            this._shadowColor = value;
            this._gradInvalid = true;
            this.renderMode = "color" /* COLOR */;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "shadowAlpha", {
        get: function () {
            return this._shadowAlpha;
        },
        set: function (value) {
            if (value === this._shadowAlpha)
                return;
            this._shadowAlpha = value;
            this._gradInvalid = true;
            this.renderMode = "color" /* COLOR */;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "highlightColor", {
        get: function () {
            return this._highlightColor;
        },
        set: function (value) {
            if (this._highlightColor === value)
                return;
            this._highlightColor = value;
            this._gradInvalid = true;
            this.renderMode = "color" /* COLOR */;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "highlightAlpha", {
        get: function () {
            return this._highlightAlpha;
        },
        set: function (value) {
            if (this._highlightAlpha === value)
                return;
            this._highlightAlpha = value;
            this._gradInvalid = true;
            this.renderMode = "color" /* COLOR */;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "angle", {
        get: function () {
            return this._angle;
        },
        set: function (value) {
            if (value === this._angle)
                return;
            this._angle = value;
            this._dirInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "distance", {
        get: function () {
            return this._distance;
        },
        set: function (value) {
            if (value === this._distance)
                return;
            this._distance = value;
            this._dirInvalid = true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "colors", {
        get: function () {
            return this._colors;
        },
        set: function (value) {
            this._colors = value;
            if (value.length) {
                this._gradInvalid = true;
                //this._shadowColor = value[0];
                //this._highlightColor = value[value.length - 1];
                this.renderMode = "gradient" /* GRADIENT */;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "alphas", {
        get: function () {
            return this._alphas;
        },
        set: function (value) {
            this._alphas = value;
            if (value.length) {
                this._gradInvalid = true;
                //this._shadowAlpha = value[0];
                //this._highlightAlpha = value[value.length - 1];
                this.renderMode = "gradient" /* GRADIENT */;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "ratios", {
        get: function () {
            return this._ratios;
        },
        set: function (value) {
            this._ratios = value;
            if (value.length) {
                this._gradInvalid = true;
                this.renderMode = "gradient" /* GRADIENT */;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "knockout", {
        get: function () {
            return this._knockout;
        },
        set: function (value) {
            if (value === this._knockout)
                return;
            this._knockout = value;
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BevelTask.prototype, "type", {
        get: function () {
            return this._type;
        },
        set: function (value) {
            if (value === this._type)
                return;
            this._type = value;
            this.invalidateProgram();
        },
        enumerable: false,
        configurable: true
    });
    BevelTask.prototype.getVertexCode = function () {
        return VERTEX;
    };
    BevelTask.prototype.getFragmentCode = function () {
        var frag = FRAG(this._renderMode, this._knockout, this._type);
        return frag;
    };
    BevelTask.prototype._regenColorMap = function () {
        if (!this._gradInvalid || this._renderMode !== "gradient" /* GRADIENT */) {
            return;
        }
        var hash = GradientAtlas.computeHash(this._colors, this._alphas, this._ratios);
        this._gradInvalid = false;
        if (this._currentHash === hash) {
            return;
        }
        var atlass = this._currentAtlass = GradientAtlas.getAtlassForHash(hash, true);
        if (atlass.hasGradient(hash)) {
            this._currentIndex = atlass.getGradient(hash).index;
        }
        else {
            this._currentIndex = atlass.setGradient(this._colors, this._alphas, this.ratios).index;
        }
        this._currentHash = hash;
        this._gradInvalid = false;
    };
    BevelTask.prototype.preActivate = function (_stage) {
        // not requre init grad for it
        if (this._renderMode !== "gradient" /* GRADIENT */) {
            return;
        }
        this._regenColorMap();
    };
    BevelTask.prototype.activate = function (_stage, _projection, _depthTexture) {
        _super.prototype.computeVertexData.call(this);
        var inputImage = this._source;
        var inputRect = this.inputRect;
        var sourceImage = this.sourceImage;
        var prog = this._program3D;
        var needUpload = prog.focusId !== this._focusId;
        prog.uploadUniform('uTexMatrix', this._vertexConstantData);
        if (needUpload || this._dirInvalid) {
            var rad = this.angle * Math.PI / 180;
            prog.uploadUniform('uDir', [
                Math.cos(rad) * this.distance / inputImage.width,
                Math.sin(rad) * this.distance / inputImage.height
            ]);
        }
        prog.uploadUniform('uStrength', this.strength);
        prog.uploadUniform('uTexMatrixSource', [
            0, 0,
            inputRect.width / sourceImage.width,
            inputRect.height / sourceImage.height,
        ]);
        inputImage.getAbstraction(_stage).activate(0);
        sourceImage.getAbstraction(_stage).activate(1);
        if (this._renderMode === "gradient" /* GRADIENT */) {
            this._currentAtlass.getAbstraction(_stage).activate(2);
            prog.uploadUniform('uGradIndex', this._currentIndex / this._currentAtlass.height);
        }
        else if (this._gradInvalid || needUpload) {
            prog.uploadUniform('uSColor', FilterUtils.colorToArray(this._shadowColor, this._shadowAlpha));
            prog.uploadUniform('uHColor', FilterUtils.colorToArray(this._highlightColor, this._highlightAlpha));
        }
        this._focusId = prog.focusId;
        this._dirInvalid = false;
    };
    return BevelTask;
}(TaskBaseWebGL));
export { BevelTask };
